import React, {Fragment} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Button, Col, Row} from "react-bootstrap";

import {NEXT_PAGE, PREVIOUS_PAGE} from "../../../Redux/Actions/Types/reportActionTypes";
import {useReportPages} from "../../../Hooks/ReportHooks";

export const PageNavigator = (props) => {
    const dispatch = useDispatch();
    const reportPages = useReportPages();

    const {pageIndex} = useSelector(state => state.reportState);
    const currentPage = reportPages[pageIndex];
    const isFirstPage = pageIndex === 0;
    const isLastPage = (pageIndex + 1 === reportPages.length);

    const actionButtons = currentPage.actions?.map((action, i) => {
        return <Button
            key={i}
            variant={action.variant ?? "secondary"}
            onClick={action.onPress}
            disabled={action.disabled ?? false}
        >
            {action.label}
        </Button>
    });

    const nextButtonParameters = () => {
        if (currentPage.action) {
            return {
                label: currentPage.action.label,
                onPress: currentPage.action.onPress,
                disabled: currentPage.action.disabled,
            };
        }

        return {
            label: 'Next',
            onPress: () => dispatch({type: NEXT_PAGE}),
            disabled: pageIndex + 1 === reportPages.length || currentPage.nextButtonDisabled,
        }
    };

    return (
        <Row>
            <Col xs={currentPage?.colSize ?? 6} md={currentPage?.colSize ?? 6}>
                <h2>{currentPage?.title || props.title}</h2>
                <div className="sb-print-hide">
                    <hr className="special-hr"/>
                </div>
                {currentPage.component}
                <div className="navigation-buttons">
                    {
                        isFirstPage ? <div /> :
                            <Button
                                variant="secondary"
                                onClick={() => dispatch({type: PREVIOUS_PAGE})}
                            >
                                Previous
                            </Button>
                    }
                    <div className="separator" />
                    {
                        isLastPage ? actionButtons :
                        <Button
                            key={'secondary'}
                            variant="secondary"
                            onClick={nextButtonParameters().onPress}
                            disabled={nextButtonParameters().disabled}
                        >
                            {nextButtonParameters().label}
                        </Button>
                    }
                </div>
            </Col>
        </Row>
    );
};


